import addEventLog from 'src/common/utils/addEventLog';

/**
 * Function to allow adding event logs in widgets that are used in Create and Engage.
 *
 * @param {String} eventName name of event to track
 * @param {Object} parameters parameters for event
 * @param {SegmentAnalytics.AnalyticsJS} aspirexAnalytics optional analytics object from aspirex
 *
 */

export default function(
  eventName: string,
  parameters: any = {},
  aspirexAnalytics?: SegmentAnalytics.AnalyticsJS
) {
  if (aspirexAnalytics) {
    parameters.aspirex = true;
    try {
      aspirexAnalytics.track(eventName, parameters);
    } catch (err) {
      console.log(`Failed to add event log for '${eventName}'`);
    }
  } else {
    parameters.aspirex = false;
    addEventLog(eventName, parameters);
  }
}
